import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/toc/HomeView.vue';
import Index from "@/views/toc/IndexToC.vue";
import NotFound from "@/components/layout/NotFound.vue";
import Forbidden from "@/components/layout/Forbidden.vue";
import LoginToC from "@/views/toc/LoginToC.vue"; // 引入我们刚刚创建的 Home 视图
import store from "@/store";
import _ from "underscore";
import {LoadingBar} from "view-design";
import {KEEP_ALIVE_VIEWS} from "@/config/constants";

// 告诉 Vue 使用 VueRouter 插件
Vue.use(VueRouter);

// 定义路由规则数组
const routes = [
  {
    // 添加一个重定向规则，当用户访问根路径 / 时，自动跳转到 redirect 对应的路径上
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home', // 未登录首页
    name: 'Home',
    component: HomeView // 加载 HomeView 组件
  },
  {
    path: '/index',//登录后首页
    name: 'Index',
    component: Index
  },{
    path: '/login',//登录页面
    name: 'Login',
    component: LoginToC
  },
  {
    path: '/notFound',
    name: 'notFound',
    component: NotFound
  }, {
    path: '/forbidden',
    name: 'forbidden',
    component: Forbidden
  }
];

// 创建 router 实例
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes // routes: routes 的缩写
});

// keepAlive views path
const keepAliveViews = KEEP_ALIVE_VIEWS

router.beforeEach((to, from, next) => {
  LoadingBar.start()
  if (store.state.token && to.path === '/login') {
    next('/hometoc')
    LoadingBar.finish()
  } else if (store.state.verify && !store.state.token && to.path !== '/login') {
    next('/login')
    LoadingBar.finish()
  } else {
    if (_.indexOf(keepAliveViews, to.path) !== -1) {
      to.meta.keepAlive = true
    }
    next()
  }
})

router.afterEach((to, from) => {
  const toMatched = to.matched && to.matched[1]
  if (toMatched) {
    store.commit('updateCurrentPath', toMatched.path)
  }
  const errorPath = ['/notFound', '/forbidden', '/serverError']
  if (_.indexOf(errorPath, to.path) !== -1) {
    LoadingBar.error()
  } else {
    LoadingBar.finish()
  }
  window.scrollTo(0, 0)
})
// 导出 router 实例
export default router;
